"use client";
import getSiteInfo from "@workspace/casino_pages/legacyLayer/client/utils/getSiteInfo";
import Script from "next/script";
import { useCallback } from "react";

declare global {
  interface Window {
    ANJ?: { init: () => void };
  }
}

const SEAL_SCRIPT_SRC_BC =
  "https://71ff64ca-2c2d-4475-99a2-accd43b06297.snippet.anjcdn.org/anj-seal.js";

const SEAL_SCRIPT_SRC_SB =
  "https://7ea79b8c-6e4d-4c17-ad27-ad20fce84c6f.snippet.anjcdn.org/anj-seal.js";

const SealScript: FC = () => {
  const { site } = getSiteInfo();
  const onLoad = useCallback(() => {
    window.ANJ?.init();
  }, []);

  return (
    <Script
      id="anjouan-seal"
      src={site === "sportsbet" ? SEAL_SCRIPT_SRC_SB : SEAL_SCRIPT_SRC_BC}
      strategy="afterInteractive"
      onLoad={onLoad}
    />
  );
};

export default SealScript;
